import { Button, ButtonProps } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import Link, { LinkProps } from "next/link"
import React from "react"

const useStyles = makeStyles()(
  (theme) => ({
    button: {
      color: theme.palette.gray.darkest,
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
      },
      // change ripple effect color
      "& > .MuiTouchRipple-root span": {
        backgroundColor: theme.palette.primary.light,
      },
      "& .MuiButton-startIcon>*:nth-of-type(1)": {
        fontSize: 24,
      },
    },
    label: {
      display: "none",
      [theme.breakpoints.up("sm")]: {
        display: "inline-block",
      },
    },
  }),
)

interface ButtonLinkProps {
  label: string
  startIcon?: ButtonProps["startIcon"]
  endIcon?: ButtonProps["endIcon"]
  href: LinkProps["href"]
  ariaLabel?: string
}

export const ButtonIconLink = (props: ButtonLinkProps) => {
  const { href, label, endIcon, startIcon, ariaLabel } = props
  const { classes } = useStyles()

  return (
    <Link href={href} passHref legacyBehavior>
      <Button
        aria-label={ariaLabel}
        className={classes.button}
        component="a"
        endIcon={endIcon}
        startIcon={startIcon}>
        <span className={classes.label}>{label}</span>
      </Button>
    </Link>
  )
}
